import React from 'react';
import PropTypes from 'prop-types';

import Translate from '@hydra/common/components/i18n';
import CriteriumTable from '@hydra/common/criterium/CriteriumTable';
import Criterium from '@hydra/common/criterium/Criterium';
import SafeAnchor from '@hydra/common/components/SafeAnchor';

export const WebFeeds = ({ criterium }) => {
  const { data } = criterium;

  const head = [
    <Translate content='web_feeds_url' key='web_feeds_url' />,
    <Translate content='web_feeds_format' key='web_feeds_format' />
  ];
  const rows = data.map(({ href, format }) => ([
    <SafeAnchor rel='nofollow noopener noreferrer' title={href} target='_blank' href={href} key={href}>
      {href}
    </SafeAnchor>,
    <span key='format'>{format}</span>
  ]));

  const content = data.length > 0
    ? (
      <>
        <Translate component='p' content='web_feeds_found' with={{ count: data.length }} />
        <CriteriumTable
          head={head}
          rows={rows}
          fixedColumns={[7, 3]}
          striped
          nowrap
        />
      </>
      )
    : <Translate content='web_feeds_not_found' />;

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

WebFeeds.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        href: PropTypes.string,
        format: PropTypes.string
      })
    )
  })
};

export default React.memo(WebFeeds);
